// @flow

import { useState } from "react";

const useBoolean: Function = (initialValue?: boolean) => {
  const [value, setValue] = useState(initialValue || false);

  const toggleBoolean = () => {
    setValue(prev => !prev);
  };

  const setFalse = () => {
    setValue(false);
  };

  const setTrue = () => {
    setValue(true);
  };

  return {
    value,
    toggleBoolean,
    setTrue,
    setFalse,
    setValue
  };
};

export default useBoolean;
